// Ünite listesi (salt-okunur). Ünite YÖNETİMİ ekranı 05'te, Faz 3'te geliyor;
// laboratuvarın fermenter numunesi açmak için listeye ihtiyacı var.

import { api } from '../../lib/api'

export type UniteOzet = {
  id: string
  kod: string
  ad: string
  durum: 'aktif' | 'bakimda' | 'pasif'
  grup: 'on' | 'cur' | 'depo' | 'gaz' | 'enerji'
}

export const uniteler = {
  liste: () => api<UniteOzet[]>('/api/uniteler'),
}
